import { MobileBottomTabBar, MobileTopHeader } from "../MobileAppShell";
import "./ConfiguredPageState.css";

function getPage(pageConfig) {
  return pageConfig?.page && typeof pageConfig.page === "object" ? pageConfig.page : {};
}

export function ConfiguredPageIntro({ pageConfig }) {
  const page = getPage(pageConfig);
  const title = String(page.title || "").trim();
  const description = String(page.description || page.summary || "").trim();
  const isRemote = pageConfig?.source && pageConfig.source !== "fallback";

  if (!isRemote || (!title && !description)) return null;

  return (
    <section className="configured-page-intro" aria-label="페이지 안내">
      {title ? <h1>{title}</h1> : null}
      {description ? <p>{description}</p> : null}
    </section>
  );
}

export function ConfiguredPageDisabledState({ pageConfig, activePath, onNavigate }) {
  const page = getPage(pageConfig);
  const title = String(page.title || page.name || "페이지").trim();
  const description = String(
    page.disabledDescription
    || page.disabled_description
    || page.description
    || "현재 이 메뉴는 준비 중입니다. 다른 메뉴를 이용해주세요.",
  ).trim();

  return (
    <section className="configured-page-disabled mobile-app-frame">
      <MobileTopHeader />
      <main>
        <span aria-hidden="true">i</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </main>
      <MobileBottomTabBar activePath={activePath} onNavigate={onNavigate} />
    </section>
  );
}

